module.exports = __webpack_public_path__ + "img/mira_550m_list.a5c56b74.jpg";